import Vue from "vue";
import App from "./App.vue";
import router from "./router";
//import store from "./store";
import { store } from "@/store";
// import 'bootstrap'
import BootstrapVue from "bootstrap-vue";
import VueLodash from "vue-lodash";
import map from "lodash/map";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret, faEnvelope,faExclamationTriangle, faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faUserSecret, faEnvelope,faExclamationTriangle, faCheckCircle, faExclamationCircle);

Vue.component("font-awesome-icon", FontAwesomeIcon);

import "./main.scss";

Vue.use(BootstrapVue);
Vue.use(VueLodash, { name: "custom", lodash: { map } });
Vue.config.productionTip = false;
Vue.config.silent = true;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
